import { computed, readonly, ref } from 'vue';
import { defineNuxtPlugin, onNuxtReady } from '#imports';

const MOBILE_BREAKPOINT = 768;

export default defineNuxtPlugin((nuxtApp) => {
    const width = ref(MOBILE_BREAKPOINT);

    const updateWidth = () => {
        if (typeof window !== 'undefined') {
            width.value = window.innerWidth;
        }
    };

    if (import.meta.client) {
        onNuxtReady(() => {
            updateWidth();
            window.addEventListener('resize', updateWidth, { passive: true });
        });

        window.addEventListener('beforeunload', () => {
            window.removeEventListener('resize', updateWidth);
        });
    }

    const screen = {
        breakpoint: MOBILE_BREAKPOINT,
        width: readonly(width),
        isMobile: computed(() => width.value < MOBILE_BREAKPOINT),
    };

    return {
        provide: {
            screen,
        },
    };
});

